import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import './i18n';

// =============================================================================
// BuildNatively SDK Type Declarations
// =============================================================================

declare global {
  interface Window {
    NativelyInfo?: new () => {
      browserInfo: () => { isNativeApp: boolean; osName?: string };
      getAppInfo: (callback: (resp: { osName: string }) => void) => void;
    };
    __NATIVE_DETECTION__?: { isNative: boolean; platform: 'ios' | 'android' | null };
  }
}

// =============================================================================
// Native App Detection - Reads from sessionStorage (set by index.html BEFORE this runs)
// =============================================================================

const detectNativeApp = (): { isNative: boolean; platform: 'ios' | 'android' | null } => {
  // sessionStorage is GUARANTEED to be set by index.html script before this runs
  try {
    const storedContainer = sessionStorage.getItem('native_container');
    const storedPlatform = sessionStorage.getItem('native_platform') as 'ios' | 'android' | null;
    
    if (storedContainer === 'natively') {
      console.log('[main.tsx] Native detected:', { platform: storedPlatform });
      return { isNative: true, platform: storedPlatform };
    }
  } catch (e) {
    console.warn('[main.tsx] sessionStorage not available');
  }

  console.log('[main.tsx] Web browser detected');
  return { isNative: false, platform: null };
};

// =============================================================================
// RUN DETECTION SYNCHRONOUSLY BEFORE REACT RENDERS
// =============================================================================

const detection = detectNativeApp();

// Store in sessionStorage for persistence
try {
  if (detection.isNative) {
    sessionStorage.setItem('native_container', 'natively');
    if (detection.platform) {
      sessionStorage.setItem('native_platform', detection.platform);
    }
  } else {
    sessionStorage.removeItem('native_container');
    sessionStorage.removeItem('native_platform');
  }
} catch (e) {
  console.warn('[main.tsx] Could not access sessionStorage');
}

// Store on window object for immediate synchronous access by React components
window.__NATIVE_DETECTION__ = detection;

console.log('[main.tsx] Final detection result:', detection);

// =============================================================================
// RENDER REACT APP
// =============================================================================

createRoot(document.getElementById("root")!).render(<App />);
